import style from './icons.module.scss';
import cx from 'classnames';

const WardrobeIcon = () => {
  return (
    <>
      <svg
        className={cx(style.icon, style.fill)}
        width="512"
        height="512"
        x="0"
        y="0"
        viewBox="0 0 64 64"
      >
        <g>
          <path
            d="M3 10c1.859 0 3.411-1.28 3.858-3h17.864c-.347.595-.985 1-1.722 1h-1a1 1 0 0 0-1 1v3.198l-8.217 1.826c-.286.063-.53.25-.668.509a1.003 1.003 0 0 0-.044.838l.448 1.119-7.83 2.558a.998.998 0 0 0-.688.896l-2 37A1 1 0 0 0 3 58h4v3a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1v-3h4a1.002 1.002 0 0 0 .999-1.054l-1.852-34.257 1.635-4.302 7.256 2.352L50.944 56h-5.903l.958-23.96-1.998-.08-1 25A1.002 1.002 0 0 0 44 58h8a1.002 1.002 0 0 0 .999-1.054L51.11 22H56v20h-3v2h4a1 1 0 0 0 1-1V22h3a.998.998 0 0 0 .895-1.447l-3-6a1.004 1.004 0 0 0-.678-.529L50 12.198V10c1.859 0 3.411-1.28 3.858-3h3.284c.447 1.72 1.999 3 3.858 3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1c-1.859 0-3.411 1.28-3.858 3h-3.284C53.411 3.28 51.859 2 50 2h-3v2h3c.737 0 1.375.405 1.722 1H37.858C37.411 3.28 35.859 2 34 2h-3v2h3c.737 0 1.375.405 1.722 1h-8.864C26.411 3.28 24.859 2 23 2h-3v2h3c.737 0 1.375.405 1.722 1H6.858C6.411 3.28 4.859 2 3 2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm57-5.731v3.463a2.001 2.001 0 0 1 0-3.463zM26.858 7h8.864c-.347.595-.985 1-1.722 1h-1a1 1 0 0 0-1 1v4c0 .469.325.875.783.976l2.708.602-1.343 2.798-2.674-.867.455-1.138a1 1 0 0 0-.712-1.347L23 12.198V10c1.859 0 3.411-1.28 3.858-3zM22 14.024l7.635 1.697-3.063 7.656-2.824-2.259 3.767-2.26a1.001 1.001 0 0 0 .193-1.564l-2-2-1.414 1.414 1.095 1.094L22 19.834l-3.388-2.033 1.095-1.094-1.414-1.414-2 2a.997.997 0 0 0 .193 1.564l3.767 2.26-2.824 2.259-3.063-7.656zM9 58h2a1.002 1.002 0 0 0 .999-1.04l-1-25-1.998.08L9.959 56H4.056l1.906-35.262 7.302-2.386 2.808 7.019a.997.997 0 0 0 .674.595.993.993 0 0 0 .88-.186l3.375-2.7V60H9zm25.041-2 .958-23.96-1.998-.08-1 25A1.002 1.002 0 0 0 33 58h2v2H23V23.081l3.375 2.7a1.004 1.004 0 0 0 1.554-.409l2.801-7.001 7.309 2.37L39.944 56zm5.337-36.916c-.024-.01-.044-.027-.07-.035l-3.241-1.051 1.428-2.975 3.159.702zM50 8h-1a1 1 0 0 0-1 1v3.198l-3.717.826.434 1.952L49 14.024l8.318 1.849L59.382 20h-8.38l-.003-.054a1 1 0 0 0-.69-.897l-7.815-2.533.441-1.16a.997.997 0 0 0-.718-1.331L34 12.198V10c1.859 0 3.411-1.28 3.858-3h13.864c-.347.595-.985 1-1.722 1zM4 4.269a1.998 1.998 0 0 1 0 3.462z"
            fill="#fff"
          />

          <path
            d="M37 52h2v2h-2zM5 52h2v2H5zM17 30h2v2h-2zM17 40h2v2h-2zM17 50h2v2h-2z"
            fill="#fff"
          />
        </g>
      </svg>
    </>
  );
};

export default WardrobeIcon;
